export const INTEGRATIONS_QUERY_KEY = 'integrations';
